<template>
  <div
    class="item-wrapper"
    :class="{'pull-out': pullOut}"
  >
    <span class="item-icon">
      <slot name="icon">
        <i class="el-icon-mobile" />
      </slot>
    </span>
    <span class="item-info">
      <slot name="text" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'ToolBoxItem',
  props: {
    pullOut: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
};
</script>

<style scoped lang="less">
    .item-wrapper{
      background: rgba(175, 175, 175, 0.4);
      border-radius: 12px 0 0 12px;
      padding: 8px 16px;
      min-width: 180px;
      color: #fff;
      cursor: default;
      position: absolute;
      right: -170px;
      transition: right 0.4s;
      display: flex;
      justify-content: space-around;
    }
    .item-wrapper:hover{
        background-color: #AE0001;
    }
    .pull-out:hover{
        right: 0;
    }
    .item-icon{
        margin-right: 10px;
    }
  .item-info{
    text-align: center;
    width: calc(100% - 22px);
  }
</style>
